import {request } from '../../../api'


export async function _fetchAlerts(data) {
  return await request('alert/list', {
    method: 'post',
    data,
  })
}

export async function _fetchAlertHistories(data) {
  return await request('alert/histories', {
    method: 'post',
    data,
  })
}

export async function _saveAlert(data) {
  return await request('alert/save', {
    method: 'post',
    data,
  })
}

export async function _removeAlert(id) {
  return await request('alert/remove', {
    method: 'post',
    data: { id },
  })
}
